import React, { Component } from 'react'
import style from './style'

import {
    withStyles,
    IconButton,
    Popper,
    Paper,
    Typography
} from '@material-ui/core'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'

class CVVInput extends Component {

    constructor(props) {
        super(props)
        this.state = {
            helpOpened: false,
            anchorEl: null,
            arrowRef: null
        }

        this.openHelp = this.openHelp.bind(this)
        this.closeHelp = this.closeHelp.bind(this)
        this.handleArrowRef = this.handleArrowRef.bind(this)
    }

    openHelp(e) {
        this.setState({
            anchorEl: e.target,
            helpOpened: true
        })
    }

    closeHelp() {
        this.setState({
            helpOpened: false
        })
    }

    handleArrowRef(node) {
        this.setState({
            arrowRef: node
        })
    }

    render() {
        const { classes, isAmex } = this.props

        const text = isAmex
            ? "El código de seguridad son los 4 dígitos que están localizados arriba del Nº de la tarjeta en el frente"
            : "El código de seguridad son los 3 últimos dígitos que están localizados detrás de la tarjeta"
        const img = isAmex ? "cvv-front.png" : "cvv-back.png"

        // TODO: estilizar bien la arrow del Popper
        return (
            <React.Fragment>
                <Popper
                    className={classes.popper}
                    open={this.state.helpOpened}
                    anchorEl={this.state.anchorEl}
                    placement="right"
                    modifiers={{
                        arrow: {
                            enabled: true,
                            element: this.state.arrowRef
                        },
                    }}
                >
                    <React.Fragment>
                        <Paper className={classes.popperContent}>
                            <img alt="" src={`${window.env.ASSETS_URL}/images/templates/${img}`} />
                            <Typography variant="body1" className={classes.helpText}>
                                {text}
                            </Typography>
                        </Paper>
                        <img alt="" src={`${window.env.ASSETS_URL}/images/templates/arrow.png`} className={classes.arrow} ref={this.handleArrowRef} />
                    </React.Fragment>
                </Popper>
                <IconButton
                    type="button"
                    id="cvvHelpButton"
                    className={classes.helpButton}
                    onMouseEnter={this.openHelp}
                    onMouseLeave={this.closeHelp}
                    tabIndex={-1}
                ><HelpOutlineIcon /></IconButton>
            </React.Fragment>
        )
    }

}

export default withStyles(style)(CVVInput)